<template>
  <section>
    <button class="bg-blue-10 p-4 mb-4 rounded text-white font-heading font-heading text-xl">
      Hello World!
    </button>
    <div class="bg-seats-waiting w-1/4">fdsjfkljdsklfjldksf</div>
  </section>
</template>
